export const getEnv = (env, publicOnly = false) => {
	const config = useRuntimeConfig();
	// Only access nitro config on the server side
	const prefix = process.server ? config.nitro?.envPrefix : 'NUXT_';
	const envKey = env.replace(/([A-Z])/g, '_$1').toUpperCase();
	const publicKey	 = `${prefix}PUBLIC_${envKey}`;
	const privateKey = `${prefix}PRIVATE_${envKey}`;
	
	if (publicOnly) return config.public[env] || process.env[publicKey] || publicKey;
	else if (process.server) return config[env] || config.public[env] || process.env[env] || process.env[publicKey] || process.env[privateKey] || privateKey;
	else return config.public[env] || process.env[publicKey] || privateKey;
};

export const getAllEnv = () => {
    return Object.fromEntries(
        Object.entries(process.env).filter(([_, value]) => typeof value !== 'object')
    )
};